PJQ.views.settings.GroupSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Groups')
    },
    events: {
        'click .add-group': 'addClicked',
        'click .edit-group': 'editClicked',
        'click .delete-group': 'deleteClicked',
        'click tr': 'selectGroup',
        'click .merge-groups': 'mergeGroups',
        'click .link-groups': 'changeLinked',
        'click .btn-sort-alpha': 'sortGroupsAlpha'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            linkStatus: (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED))
        };
    },
    afterRender: function () {
        $('.link-groups').prop('hidden', !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY));
        $('.current-status').prop('hidden', !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY));
        if (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED)) {
            let $button = $('.link-groups');
            $button.append("Unlink All Groups");
        } else {
            $('.link-groups').append("Link Groups");
        }

        this.groupLevels = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS));
        this.groupLevels = this.groupLevels ? this.groupLevels : 1;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".group-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new group'
            },
            sortableOptions: {
                data: this.collection,
                containment: ".group-table"
            },
            pageLength: 50,
            bSort: false,
            onRowDoubleClick: _.bind(function (row) {
                let groupArr = _.each(this.collection.models, function (model) {
                    let groups = [];
                    groups.push(model.attributes.groupName);
                    return groups
                }, this);
                this.editGroup(row.data(), groupArr);
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            let groupArr = _.each(this.collection.models, function (model) {
                                let groups = [];
                                groups.push(model.attributes.groupName);
                                return groups
                            }, this);
                            this.editGroup(row.data(), groupArr);
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteGroup(row);
                        }, this)

                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (data != null) {
                            content = '<div><i class="fas fa-sort"></i></div>'
                        }

                        return content
                    }, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.groupName",
                    "orderable": true
                },
                {
                    "title": "Parent Group",
                    "defaultContent": "",
                    "data": "attributes.groupDescription",
                    "orderable": true,
                    "render": _.bind(function (data) {
                        if (data.includes("|")) {
                            return data.replace(/\|/g, " / ")
                        } else {
                            return data
                        }
                    })
                },
                {
                    "title": "Created On",
                    "data": "attributes.createdOn",
                    "orderable": true,
                    "render": _.bind(function (data) {
                        if (data) {
                            let date = PJQ.helpers.dateHelpers.parseDateString(data);
                            return PJQ.helpers.dateHelpers.getDateString(date, "MM/dd/yyyy")
                        }
                    })
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info edit-group ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-group ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
                    }, this)
                }
            ]
        });

        this.groupLevelSelect = new PJQ.inputs.Selectpicker({
            el: this.$('.input-group-levels'),
            defaultValue: this.groupLevels,
            onChange: _.bind(function (value) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Change Group Levels?",
                    body: 'Changing group levels will delete all existing parent groups.  Do you still want to change group levels?',
                    deleteButtonText: "Confirm",
                    deleteButtonColorClass: 'success',
                    declineButtonText: "Decline",
                    declineButtonColorClass: "danger",
                    onDelete: _.bind(function () {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'groups',
                                    value: 'level'
                                }
                            ], [
                                {
                                    parameter: 'level',
                                    value: value
                                }
                            ])
                        }).post().done(_.bind(function () {
                            PJQ.app.session.fetch({
                                success: _.bind(function () {
                                    PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.GROUP_LEVELS, value);
                                    this.collection.fetch({
                                        success: _.bind(function () {
                                            PJQ.notifications.notify.successNotify({
                                                message: 'Group Level Successfully Changed'
                                            });
                                            this.render()
                                        }, this)
                                    });
                                }, this)
                            });
                        }, this));
                    }, this),
                    onCancel: _.bind(function () {
                        this.render()
                    }, this)
                });
            }, this)
        });
    },
    addClicked: function () {
        let newGroup = new this.options.groupModel({
            groupName: "",
            groupDescription: "",
            sortOrder: this.collection.length + 1,
            createdOn: PJQ.helpers.dateHelpers.getDateString(new Date(), "MM/dd/yyyy")
        });
        let groupArr = _.each(this.collection.models, function (model) {
            let groups = [];
            groups.push(model.attributes.groupName);
            return groups
        }, this);
        this.editGroup(newGroup, groupArr);
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            group = row.data(),
            groupArr = _.each(this.collection.models, function (model) {
                let groups = [];
                groups.push(model.attributes.groupName);
                return groups
            }, this);

        this.editGroup(group, groupArr);
    },
    changeLinked: function () {
        let isLinked = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED);
        if (!isLinked) {
            new PJQ.views.settings.GroupLinkModal({
                onSuccess: _.bind(function () {
                    PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED, !isLinked);
                    PJQ.notifications.notify.successNotify({
                        message: 'Groups successfully Linked'
                    });
                    this.render();
                }, this),
                onError: _.bind(function () {
                    PJQ.notifications.notify.errorNotify({
                        message: 'An error has occurred.  Please check and make sure you have selected an excel file, and that it is correctly formatted.'
                    });
                }, this)
            })
        } else {
            new PJQ.views.modals.YesNo({
                header: "Unlink Groups",
                body: 'Are you sure you would like to unlink groups?',
                onYes: _.bind(function () {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'groups',
                                value: 'unlink'
                            }
                        ])
                    }).post().done(_.bind(function () {
                        PJQ.app.session.fetch({
                            success: _.bind(function () {
                                PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED, !isLinked);
                                PJQ.notifications.notify.successNotify({
                                    message: 'Groups successfully Unlinked'
                                });
                                this.render();
                            }, this)
                        });
                    }, this));
                }, this)
            });
        }
    },
    editGroup: function (group, extra) {
        new PJQ.views.settings.EditGroupModal({
            model: group,
            groupArr: extra,
            groupLevels: this.groupLevels,
            onSave: _.bind(function (group) {
                let isNew = group.isNew();
                if (group.hasChanged() || isNew) {
                    group.save(null, {
                        notify: true,
                        success: () => {
                            if (isNew) {
                                this.collection.add(group);
                                this.dataTable.addRow(group);
                            }
                            this.dataTable.refresh();
                        }
                    });
                }
            }, this),
            onClose: _.bind(function (group) {
                if (group ? group.hasChanged() : group) {
                    group.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (group) {
                if (group.id > 0) {
                    let row = this.dataTable.getRow(group.cid);
                    this.collection.remove(group);
                    group.destroy();
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        });
    },
    sortGroupsAlpha: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'groups',
                    value: 'sortalpha'
                },
            ]), data: {
                groupLevels: this.groupLevels
            }
        }).put().done(_.bind(function () {
            this.collection.fetch({
                success: _.bind(function () {
                    PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.GROUP_LEVELS, parseInt(this.groupLevelSelect.getValue()));
                    this.dataTable.render();
                }, this)
            });
        }, this));
    },
    selectGroup: function (e) {
        if (e.ctrlKey === true) {
            let target = $(e.currentTarget);
            target.toggleClass('selected');
            this.checkMergeButton()
        }
    },
    checkMergeButton: function () {
        if (this.dataTable.dataTable.rows('.selected').data().length >= 2) {
            $('.merge-groups').attr('disabled', false);
        } else {
            $('.merge-groups').attr('disabled', true);
        }
    },
    mergeGroups: function () {
        let groupArray = [];
        _.each(this.dataTable.dataTable.rows('.selected').data(), function (group) {
            groupArray.push(group)
        });
        new PJQ.views.settings.MergeGroupsModal({
            groups: groupArray,
            onSave: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        let page = this.dataTable.dataTable.page();
                        this.$('.merge-groups').attr('disabled', true);
                        this.dataTable.render();
                        this.dataTable.dataTable.page(page).draw('page');
                    }, this)
                });

            }, this)
        })
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteGroup(row);
    },
    deleteGroup: function (row) {
        let group = row.data();

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this field?",
            onDelete: _.bind(function () {
                this.collection.remove(group);
                group.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.MergeGroupsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Merge-Groups'),
        maxWidth: 250
    },
    events: {
        'click .merge-save': 'splitGroups',
        'click .merge-close': 'onClose'
    },
    beforeRender: function () {
        this.renderData = {
            groups: this.options.groups
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.mergePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.merge-groups'),
            onChange: _.bind(function (value) {

            }, this)
        });
    },
    onClose: function () {
        this.removeModal()
    },
    splitGroups: function () {
        let mergeInto = parseInt(this.mergePicker.getValue()),
            mergeGroups = [];
        _.each(this.options.groups, function (group) {
            if (group.get('groupId') !== mergeInto) {
                mergeGroups.push(group.get('groupId'))
            }
        });
        mergeGroups = mergeGroups.join('|');
        this.onSave(mergeInto, mergeGroups)
    },
    onSave: function (group, mergeGroups) {
        let loader = new PJQ.Loader(this.$('.modal-body'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'groups',
                    value: 'merge'
                },
            ], [
                {
                    parameter: 'groupId',
                    value: group
                },
                {
                    parameter: 'groupIdToMerge',
                    value: mergeGroups
                }
            ])
        }).put().done(_.bind(function () {
            loader.remove();
            this.options.onSave();
            this.removeModal();
        }, this));
    }
});

PJQ.views.settings.EditGroupModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Edit-Groups'),
        maxWidth: 600
    },
    events: {
        'click .group-save': 'validate',
        'click .group-close': 'close',
        'click .group-delete': 'delete',
        'focusout .group-desc': 'updateTotal',
        'focusout .group-desc-sub': 'updateTotal',
        "click .btn-new-parent": "groupTwoNew",
        'click .btn-existing-parent': "groupTwoExisting",
        "click .btn-new-sub-parent": "groupThreeNew",
        'click .btn-existing-sub-parent': "groupThreeExisting",
        'click .change-to-existing': "groupTwoExisting",
        'click .change-to-existing-sub': "groupThreeExisting"
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            options: this.options,
            groupArr: this.options.groupArr
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });
        this.groupTwoPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-parent-group'),
            noneSelectedText: 'Select Parent Group',
            defaultValue: this.model.get('groupDescription').split('|')[0],
            onChange: _.bind(function (value) {
                if (this.options.groupLevels === 2) {
                    this.model.set('groupDescription', value);
                }
                if (this.options.groupLevels === 3) {
                    this.$('.group-desc').val(value);
                    this.updateTotal();
                }
            }, this),
            liveSearch: true
        });

        this.groupThreePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-sub-parent-group'),
            noneSelectedText: 'Select Sub-Parent Group',
            defaultValue: this.model.get('groupDescription').split('|')[1],
            onChange: _.bind(function (value) {
                if (this.options.groupLevels === 3) {
                    this.$('.group-desc-sub').val(value);
                    this.updateTotal();
                }
            }, this),
            liveSearch: true
        });
        this.showExistButtons()
    },
    showExistButtons: function () {
        let show = [],
            subShow = [];
        _.each(this.options.groupArr, function (model) {
            if (_.size(model.get('groupDescription')) > 0) {
                show.push(model);
                if (model.get('groupDescription').includes('|')) {
                    subShow.push(model);
                }
            }
        });
        if (_.size(show) > 0) {
            $('.btn-existing-parent').attr('hidden', false);
        }
        if (_.size(subShow) > 0) {
            $('.btn-existing-sub-parent').attr('hidden', false);
        }
    },
    updateTotal: function () {
        if (this.options.groupLevels === 3 && this.$('.group-desc-sub').val().length > 0) {
            this.$('.group-desc-total').val(this.$('.group-desc').val() + "|" + this.$('.group-desc-sub').val())
        } else {
            this.$('.group-desc-total').val(this.$('.group-desc').val())
        }
    },
    groupTwoNew: function () {
        $('.new-or-existing-parent').hide();
        $('.new-parent-group').attr('hidden', false);
    },
    groupTwoExisting: function () {
        this.model.get('groupDescription').length > 0 ? $('.parent-group').hide() : $('.new-or-existing-parent').hide();
        $('.existing-parent-group').attr('hidden', false);
        this.groupTwoPicker.updateChoices(_.each([...new Set(_.map(_.filter(this.options.groupArr, _.bind(function (item) {
            return (_.size(item.attributes.groupDescription) > 0);
        }, this)), function (item) {
            return item.attributes.groupDescription.split(/\|/)[0]
        }))], function (arr) {
            return arr;
        }))
    },
    groupThreeNew: function () {
        $('.new-or-existing-sub-parent').hide();
        $('.new-sub-parent-group').attr('hidden', false);
    },
    groupThreeExisting: function () {
        this.model.get('groupDescription').length > 0 ? $('.sub-parent-group').hide() : $('.new-or-existing-sub-parent').hide();
        $('.existing-sub-parent-group').attr('hidden', false);
        this.groupThreePicker.updateChoices(_.each([...new Set(_.map(_.filter(this.options.groupArr, _.bind(function (item) {
            return item.attributes.groupDescription.includes("|")

        }, this)), function (item) {
            return item.attributes.groupDescription.split(/\|/)[1]
        }))], function (set) {
            return set
        }))
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
        let match = 0,
            errors = 0,
            errorMsg = "",
            id = this.model.get('groupId');
        if (this.$('.input-group-name').val().length <= 0) {
            errorMsg += "Name must be included";
            errors++
        }
        _.each(this.options.groupArr, function (model) {
            if (model.attributes.groupId !== id)
                if (model.attributes.groupName === this.$('.input-group-name').val()) {
                    match++
                }

        }, this);
        if (match > 0) {
            errors++;
            errorMsg += "Group name already exists"

        }
        if (errors === 0) {
            this.save();
        } else {
            this.renderError(errorMsg)
        }
    },
    renderError: function (text) {
        this.$('.group-save').prop('disabled', false);
        this.errorAlert = new PJQ.Alert(this.$('.error'), {
            type: 'danger',
            text: text
        });
    },
    save: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
        if (this.options.onSave) {
            if (this.options.groupLevels === 3 && this.$('.group-desc-total').val().length > 0) {
                this.model.set('groupDescription', this.$('.group-desc-total').val());
            }
            this.options.onSave(this.model);
            this.removeModal();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this field?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.settings.GroupLinkModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Link-Groups'),
        maxWidth: 600
    },
    afterRender: function () {
        let isLinked = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED);
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.group-map-file-uploader'),
            canUpload: true,
            dictDefaultMessage: "Drop Trade Mapping file here or click to upload",
            canDelete: false,
            isRemoveOnComplete: true,
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'groups',
                    value: 'link'
                }
            ]),
            onSuccess: _.bind(function () {
                this.removeModal();
                this.options.onSuccess();
            }, this),
            onError: _.bind(function (result) {
                this.removeModal();
                this.options.onError()
            }, this)
        });
    }
});
